import React from 'react';
import { Input, Select } from '@/components/ui';
import type { UserEditFormData } from '../types/userEdit.types';

interface EditBasicInfoProps {
  formData: UserEditFormData;
  updateField: (field: keyof UserEditFormData, value: any) => void;
}

export function EditBasicInfo({ formData, updateField }: EditBasicInfoProps) {
  return (
    <div className="bg-white rounded-md p-6 border border-slate-100 w-full h-full">
      <h2 className="sm:text-sm text-xs font-medium text-slate-800 mb-6">Thông tin cơ bản</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Họ và tên"
          placeholder="Nhập họ và tên"
          value={formData.full_name}
          onChange={(e: any) => updateField('full_name', e.target.value)}
        />
        <Select
          label="Giới tính"
          value={formData.gender}
          onValueChange={(val: any) => updateField('gender', val)}
          options={[
            { value: 'male', label: 'Nam' },
            { value: 'female', label: 'Nữ' },
            { value: 'other', label: 'Khác' },
          ]}
        />
        <Input
          label="Năm sinh"
          type="number"
          placeholder="Ví dụ: 1990"
          value={formData.birth_year?.toString() || ''}
          onChange={(e: any) => updateField('birth_year', e.target.value)}
        />
        <Input
          label="Số điện thoại"
          placeholder="Nhập số điện thoại"
          value={formData.phone}
          onChange={(e: any) => updateField('phone', e.target.value)}
        />
        <Input
          label="Email"
          type="email"
          placeholder="Nhập email"
          value={formData.email}
          onChange={(e: any) => updateField('email', e.target.value)}
        />
        <Select
          label="Trạng thái"
          value={formData.status}
          onValueChange={(val: any) => updateField('status', val)}
          options={[
            { value: 'active', label: 'Đang làm việc' },
            { value: 'on_leave', label: 'Nghỉ phép' },
            { value: 'suspended', label: 'Tạm nghỉ' },
            { value: 'resigned', label: 'Đã nghỉ việc' },
          ]}
        />
        <Input
          label="CCCD/CMND"
          placeholder="Nhập số CCCD"
          value={formData.id_number || ''}
          onChange={(e: any) => updateField('id_number', e.target.value)}
        />
        <div className="md:col-span-2">
          <Input
            label="Địa chỉ thường trú"
            placeholder="Nhập địa chỉ"
            value={formData.address || ''}
            onChange={(e: any) => updateField('address', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
